import { Injectable } from '@angular/core';
import { BorrowerDTO } from '../../models/borrower/borrower-dto';
import { IncomeDTO } from '../../models/borrower/income-dto';
import { LoanStep3 } from '../../models/borrower/loan-step3';
import { OTP } from '../../models/OTP/OTP';
import { CstIndiIncomeEntityIdDto } from '../../models/borrower/cst-indi_income_entity_id-dto';
import { LoanBorrowerDTO } from 'src/app/models/borrower/loan-borrower-dto';
import { Parameter } from 'src/app/models/borrower/loanFormParameter';
import { LoanStep1 } from 'src/app/models/borrower/loan-step1';
import { LoanStep2 } from 'src/app/models/borrower/loan-step2';
import { LoanStep4 } from 'src/app/models/borrower/loan-step4';
import { DownPayment } from 'src/app/models/borrower/downPayment';
import { DocListDTO } from 'src/app/models/borrower/doc-list-dto';

@Injectable({
  providedIn: 'root'
})
export class BorrowerRenderingService {

  _primaryBorrower: BorrowerDTO;
  _coApplicantBorrower: BorrowerDTO;
  _incomeBorrower: IncomeDTO;
  _incomeCoBorrower: IncomeDTO;
  _docBorrower: DocListDTO;
  _loanStep1: LoanStep1;
  _loanStep2: LoanStep2;
  _loanStep3: LoanStep3;
  _loanStep4: LoanStep4;
  _typeOfApplicant: string;
  _OTP: OTP;
  _temp: number;
  _customerId: CstIndiIncomeEntityIdDto;
  _coCustomerId: CstIndiIncomeEntityIdDto;
  _listPrimaryBorrower: BorrowerDTO[] = [];
  _listIncomeBorrower: IncomeDTO[] = [];
  _listDocBorrower: DocListDTO[] = [];
  _parameter: Parameter;
  _downPayment: DownPayment;
  loanBorrower: LoanBorrowerDTO;
  backFlag: boolean;
  editFlag: boolean;
  loanFlag: boolean;
  docFlag: boolean;
  docErrorFlag: boolean;
  language: string;

  constructor() {
    this.primaryBorrower = new BorrowerDTO();
    this.coApplicantBorrower = new BorrowerDTO();
    this.incomeBorrower = new IncomeDTO();
    this.incomeCoBorrower = new IncomeDTO();
    this.docBorrower = new DocListDTO();
    this.loanStep1 = new LoanStep1();
    this.loanStep2 = new LoanStep2();
    this.loanStep3 = new LoanStep3();
    this.loanStep4 = new LoanStep4();
    this.OTP = new OTP();
    this.parameter = new Parameter();
    this.downpayment = new DownPayment();
    //  this.customerId = new CstIndiIncomeEntityIdDto();
    //this.coCustomerId =new CstIndiIncomeEntityIdDto();
  }

  public get primaryBorrower(): BorrowerDTO {
    return this._primaryBorrower;
  }

  public set primaryBorrower(value: BorrowerDTO) {
    this._primaryBorrower = value;
  }

  public get incomeBorrower(): IncomeDTO {
    return this._incomeBorrower;
  }


  public set incomeBorrower(value: IncomeDTO) {
    this._incomeBorrower = value;
  }

  public get incomeCoBorrower(): IncomeDTO {
    return this._incomeCoBorrower;
  }

  public set incomeCoBorrower(value: IncomeDTO) {
    this._incomeCoBorrower = value;
  }

  public get docBorrower(): DocListDTO {
    return this._docBorrower;
  }

  public set docBorrower(value: DocListDTO) {
    this._docBorrower = value;
  }

  public get coApplicantBorrower(): BorrowerDTO {
    return this._coApplicantBorrower;
  }

  public set coApplicantBorrower(value: BorrowerDTO) {
    this._coApplicantBorrower = value;
  }

  public get loanStep1(): LoanStep1 {
    return this._loanStep1;
  }

  public set loanStep1(value: LoanStep1) {
    this._loanStep1 = value;
  }

  public get loanStep2(): LoanStep2 {
    return this._loanStep2;
  }

  public set loanStep2(value: LoanStep2) {
    this._loanStep2 = value;
  }

  public get loanStep3(): LoanStep3 {
    return this._loanStep3;
  }

  public set loanStep3(value: LoanStep3) {
    this._loanStep3 = value;
  }

  public get loanStep4(): LoanStep4 {
    return this._loanStep4;
  }

  public set loanStep4(value: LoanStep4) {
    this._loanStep4 = value;
  }

  public get typeOfApplicant(): string {
    return this._typeOfApplicant;
  }

  public set typeOfApplicant(value: string) {
    this._typeOfApplicant = value;
  }

  public get OTP(): OTP {
    return this._OTP;
  }

  public set OTP(value: OTP) {
    this._OTP = value;
  }

  // public get customerId(): CstIndiIncomeEntityIdDto {
  //   return this._customerId;
  // }

  // public set customerId(value: CstIndiIncomeEntityIdDto) {
  //   this._customerId = value;
  // }

  // public get coCustomerId(): CstIndiIncomeEntityIdDto {
  //   return this._coCustomerId;
  // }

  // public set coCustomerId(value: CstIndiIncomeEntityIdDto) {
  //   this._coCustomerId = value;
  // }


  public get listPrimaryBorrower(): BorrowerDTO[] {
    return this._listPrimaryBorrower;
  }

  public set listPrimaryBorrower(value: BorrowerDTO[]) {
    this._listPrimaryBorrower = value;
  }

  public get listIncomeBorrower(): IncomeDTO[] {
    return this._listIncomeBorrower;
  }

  public set listIncomeBorrower(value: IncomeDTO[]) {
    this._listIncomeBorrower = value;
  }

  public get parameter(): Parameter {
    return this._parameter;
  }

  public set parameter(value: Parameter) {
    this._parameter = value;
  }

  public get downpayment(): DownPayment {
    return this._downPayment;
  }

  public set downpayment(value: DownPayment) {
    this._downPayment = value;
  }

  
}
